export const LOCALE = process.env.LOCALE
export const atCol = LOCALE === "es-CO"
